import { render, staticRenderFns } from "./KeyboardUp.vue?vue&type=template&id=61d6f108&scoped=true&"
import script from "./KeyboardUp.vue?vue&type=script&lang=js&"
export * from "./KeyboardUp.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardUp.vue?vue&type=style&index=0&id=61d6f108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6f108",
  null
  
)

export default component.exports